import { BRAND_GRADIENT } from '@shared/styles/brand';

/**
 * 20px gradient check circle — the feature-bullet glyph on every pricing card (Figma). Always the
 * brand gradient, never a token colour: it's a decorative accent, not a status pill.
 */
export function CheckCircle() {
  return (
    <span
      aria-hidden="true"
      className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
      style={{ background: BRAND_GRADIENT }}
    >
      <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 4.2L3.6 6.8L9 1" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}
